import * as React from 'react'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'

type TProps = {
  type?: 'feed' | 'modal' | 'card'
  className?: string
}

const NewsItemContentLoading: React.FC<TProps> = ({
  type = 'feed',
  className,
}) => {
  return (
    <StyledWrapper className={className} data-type={type}>
      <div className={`description`}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      <div className="NewsItemImageSlider"></div>
    </StyledWrapper>
  )
}

export default NewsItemContentLoading

const StyledWrapper = styled.div`
  & > .description {
    margin: 0 20px 12px;
    .line {
      width: 100%;
      height: 22px;
      background-color: #eee;
      border-radius: 5px;
      margin-bottom: 10px;
    }
  }

  ${mobileBreakPoint} {
    &[data-type='card'] {
      .description {
        margin: 0 15px;
      }
    }
  }
`
